export default __webpack_public_path__ + "static/media/project_thumbnail_kf.80263af7.png";